import { GenLogisticTypeModel } from '@/Models';
import { createSlice } from '@reduxjs/toolkit';
import { asyncActions } from './asyncActions';
import { arrayUtils } from '@/Utils';

export type GenLogisticTypesDataState = {
  logisticTypes: GenLogisticTypeModel[];
};

const initialState: GenLogisticTypesDataState = {
  logisticTypes: [],
};

const genLogisticTypesDataSlice = createSlice({
  name: 'genLogisticTypesData',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(asyncActions.getLogisticTypes.fulfilled, (state, action) => {
        state.logisticTypes = arrayUtils.sortBy(action.payload, 'name');
      })
      .addCase(asyncActions.createLogisticType.fulfilled, (state, action) => {
        const result = [action.payload.logisticType, ...state.logisticTypes];
        state.logisticTypes = arrayUtils.sortBy(result, 'name');
      })
      .addCase(asyncActions.updateLogisticType.fulfilled, (state, action) => {
        const { logisticType } = action.payload;

        const result = state.logisticTypes.map((item) => {
          return item.id === logisticType.id ? logisticType : item;
        });

        state.logisticTypes = arrayUtils.sortBy(result, 'name');
      })
      .addCase(asyncActions.deleteLogisticType.fulfilled, (state, action) => {
        state.logisticTypes = state.logisticTypes.filter((item) => item.id !== action.payload);
      });
  },
});

export const genLogisticTypesDataReducer = genLogisticTypesDataSlice.reducer;
export const genLogisticTypesDataActions = genLogisticTypesDataSlice.actions;
export const genLogisticTypesDataAsyncActions = asyncActions;
